export default __webpack_public_path__ + "static/media/pokemon_uncommon.6d4eec87.svg";